import angular from 'angular';
import FileListComponent from './file-list.component';

export default angular
  .module('verifyApp.fileList', [])
  .component('fileList', FileListComponent)
  .name;



// WEBPACK FOOTER //
// ./client/components/file-list/index.js